import { cn } from "@/lib/utils";

// A small labelled tag that discloses how an output was derived — supports
// the ORBIT transparency principle (Based on responses / Calculated / Rule /
// AI-generated / Requires verification).
const VARIANTS = {
  responses: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/25",
  calculated: "bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/25",
  rule: "bg-teal-500/10 text-teal-700 dark:text-teal-300 border-teal-500/25",
  ai: "bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/25",
  verify: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/25",
};

const LABELS = {
  responses: "Based on your responses",
  calculated: "Calculated",
  rule: "System rule",
  ai: "AI-generated insight",
  verify: "Requires verification",
};

export function SourceBadge({ type = "calculated", className }) {
  return (
    <span
      data-testid={`source-badge-${type}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-wide",
        VARIANTS[type],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {LABELS[type]}
    </span>
  );
}
